import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevron = (props) => (_jsx("svg", { width: 12, height: 7, fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: _jsx("path", { d: "M11 6 6 1 1 6", stroke: "currentColor" }) }));
export default SvgChevron;
//# sourceMappingURL=Chevron.js.map